<template>
  <div class="createPage">
    <!-- header start -->
    <van-nav-bar
      title="创建纪念馆"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <!-- header end -->

    <img src="@/assets/images/create/step02_bg.jpg" class="createBg" />

    <div class="block step02">
      <div v-if="isPersonOne">
        <div class="title">{{ step != 1 ? "第一位逝者" : "" }}</div>

        <div class="avatar-uploader">
          <van-uploader :after-read="afterReadfirst">
            <div class="avatar"><img :src="firstimg" /></div>
            <p class="tips">添加逝者照片</p>
          </van-uploader>
        </div>
        <div>
          <div class="field-item">
            <div class="hd"><i class="iconfont iconnav_me"></i></div>
            <div class="bd">
              <van-field v-model="first.FirstFullName" placeholder="姓名" />
            </div>
          </div>
          <div class="field-item" @click="selectSexShow = true">
            <div class="hd"><i class="iconfont iconm_sex"></i></div>
            <div class="bd">
              <van-field v-model="selectSex" readonly placeholder="性别" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
          <div class="field-item" @click="startDateShow = true">
            <div class="hd"><i class="iconfont iconm_birthday-copy"></i></div>
            <div class="bd">
              <van-field v-model="startDate" readonly placeholder="生辰" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
          <div class="field-item" @click="endDateShow = true">
            <div class="hd"><i class="iconfont iconm_jr"></i></div>
            <div class="bd">
              <van-field v-model="endDate" readonly placeholder="忌日" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
        </div>

        <div class="btn-area">
          <van-button
            round
            plain
            class="whitebtn minbtn"
            @click="onIsPersonOne()"
            >下一步</van-button
          >
        </div>
      </div>
      <div v-else>
        <div class="title">第二位逝者</div>

        <div class="avatar-uploader">
          <van-uploader :after-read="afterReadsecond">
            <div class="avatar"><img :src="secondimg" /></div>
            <p class="tips">再添加一位</p>
          </van-uploader>
        </div>
        <div>
          <div class="field-item">
            <div class="hd"><i class="iconfont iconnav_me"></i></div>
            <div class="bd">
              <van-field v-model="second.SecondFullName" placeholder="姓名" />
            </div>
          </div>
          <div class="field-item" @click="selectSexShow = true">
            <div class="hd"><i class="iconfont iconm_sex"></i></div>
            <div class="bd">
              <van-field v-model="selectSex" readonly placeholder="性别" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
          <div class="field-item" @click="startDateShow = true">
            <div class="hd"><i class="iconfont iconm_birthday-copy"></i></div>
            <div class="bd">
              <van-field v-model="startDate" readonly placeholder="生辰" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
          <div class="field-item" @click="endDateShow = true">
            <div class="hd"><i class="iconfont iconm_jr"></i></div>
            <div class="bd">
              <van-field v-model="endDate" readonly placeholder="忌日" />
            </div>
            <div class="ft">
              <van-icon name="arrow" color="#fff" size="16" />
            </div>
          </div>
        </div>

        <div class="btn-area">
          <van-button
            round
            plain
            class="whitebtn minbtn"
            @click="goStep()"
            replace
            >下一步</van-button
          >
        </div>
      </div>
    </div>

    <!-- 性别选择 popup start -->
    <van-popup v-model="selectSexShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="['女', '男']"
        cancel-button-text=""
        confirm-button-text="确定"
        :visible-item-count="3"
        @confirm="onConfirmSex"
        @cancel="selectSexShow = false"
      />
      <!-- @change="onSexChange" -->
    </van-popup>
    <!-- 性别选择 popup end -->
    <!-- 开始时间 popup start -->
    <van-popup v-model="startDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择生辰"
        v-model="currenDate"
        type="date"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirmstartDateShow"
        @cancel="startDateShow = false"
        @change="startDateChange"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeNl(1)" style="width: 100%; padding: 5px">
              切换农历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanSc" style="width: 100%; padding: 4px">
              清除生辰
            </button>
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>
    <!-- 开始时间 popup end -->
    <!-- 结束时间 popup start -->
    <van-popup v-model="endDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择忌日"
        v-model="currenDate"
        type="date"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirmEndDateShow"
        @cancel="endDateShow = false"
        @change="endDateChange"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeNl(2)" style="width: 100%; padding: 4px">
              切换农历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanJr" style="width: 100%; padding: 4px">
              清除忌日
            </button>
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>
    <!-- 结束时间 popup end -->

    <!-- 开始时间 popup end -->
    <van-popup v-model="nlShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="confirmNl"
        @cancel="nlShow = false"
      >
        <template slot="columns-bottom">
          <div style="padding: 1px">
            <button @click="changeYl()" style="width: 100%; padding: 5px">
              切换阳历
            </button>
            <br />
            <div style="border: 1px solid silver;" />
            <button @click="cleanDate" style="width: 100%; padding: 5px">
              {{ dateType == 1 ? "清除生辰" : "清除忌日" }}
            </button>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      isPersonOne: true,

      selectSex: "",
      selectSexShow: false,
      currenDate: new Date(),
      maxDate: new Date(),
      minDate: new Date("1700-01-01"),
      startDateShow: false,
      startDate: "",
      endDateShow: false,
      endDate: "",
      step: 1,
      stepindex: 0,
      firstimg: require("@/assets/images/create/m_member.png"),
      secondimg: require("@/assets/images/create/m_member02.png"),
      first: {
        FirstFullName: "",
        FirstGender: null,
        FirstBirthdayDateMode: 1,
        FirstNlBirthdayList: null,
        FirstPassAwayDateMode: 1,
        FirstNlPassAwayList: null,
        FirstBirthdayDateTime: null,
        FirstPassAwayDateTime: null,
        FirstImg: null,
      },
      second: {
        SecondFullName: "",
        SecondGender: null,
        SecondBirthdayDateMode: 1,
        SecondNlBirthdayList: null,
        SecondPassAwayDateMode: 1,
        SecondNlPassAwayList: null,
        SecondBirthdayDateTime: null,
        SecondPassAwayDateTime: null,
        SecondImg: null,
      },
      columns: [
        {
          values: ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"],
          defaultIndex: 0,
        },
        {
          values: [
            "子",
            "丑",
            "寅",
            "卯",
            "辰",
            "巳",
            "午",
            "未",
            "申",
            "酉",
            "戌",
            "亥",
          ],
          defaultIndex: 0,
        },
        {
          values: [
            "",
            "正",
            "二",
            "三",
            "四",
            "五",
            "六",
            "七",
            "八",
            "九",
            "十",
            "十一",
            "腊",
          ],
          defaultIndex: 0,
        },
        {
          values: [
            "",
            "初一",
            "初二",
            "初三",
            "初四",
            "初五",
            "初六",
            "初七",
            "初八",
            "初九",
            "初十",
            "十一",
            "十二",
            "十三",
            "十四",
            "十五",
            "十六",
            "十七",
            "十八",
            "十九",
            "二十",
            "廿一",
            "廿二",
            "廿三",
            "廿四",
            "廿五",
            "廿六",
            "廿七",
            "廿八",
            "廿九",
            "三十",
          ],
          defaultIndex: 0,
        },
      ],
      dateType: 1,
      nlShow: false,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onSexChange(picker, value, index) {
      //console.log(`当前值：${value}, 当前索引：${index}`);
      this.selectSex = value;
    },
    onConfirmSex(value, index) {
      this.selectSexShow = false;
      this.selectSex = value;
      if (this.stepindex == 0) {
        this.first.FirstGender = index + 1;
      } else {
        this.second.SecondGender = index + 1;
      }
    },
    startDateChange(picker, value, index) {
      //console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.startDate =
        dateArray[0].replace("年", "") +
        "-" +
        dateArray[1].replace("月", "") +
        "-" +
        dateArray[2].replace("日", "");
      this.changeStartDate();
    },
    onConfirmstartDateShow(picker) {
      this.startDate = this.$moment(picker).format("YYYY-MM-DD");
      this.startDateShow = false;
      this.changeStartDate();
    },
    changeStartDate() {
      if (this.stepindex == 0) {
        //第一位逝者
        this.first.FirstBirthdayDateTime = this.startDate;
      } else {
        this.second.SecondBirthdayDateTime = this.startDate;
      }
    },
    endDateChange(picker, value, index) {
      //console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.endDate =
        dateArray[0].replace("年", "") +
        "-" +
        dateArray[1].replace("月", "") +
        "-" +
        dateArray[2].replace("日", "");
      this.changeEndDate();
    },
    onConfirmEndDateShow(picker) {
      this.endDate = this.$moment(picker).format("YYYY-MM-DD");
      this.endDateShow = false;
      this.changeEndDate();
    },
    changeEndDate() {
      if (this.stepindex == 0) {
        this.first.FirstPassAwayDateTime = this.endDate;
      } else {
        this.second.SecondPassAwayDateTime = this.endDate;
      }
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },
    onIsPersonOne() {
      var that = this;
      if (!this.first.FirstFullName || this.first.FirstFullName.length == 0) {
        Toast("姓名不能为空");
        return;
      }
      if (this.step == 1) {
        this.isPersonOne = true;
        this.$router.replace({
          name: "Step03",
          params: { first: this.first, peopleCount: 1 },
        });
      } else {
        this.isPersonOne = false;
        this.stepindex = 1;
      }
      this.startDate = "";
      this.endDate = "";
      this.selectSex = "";
      console.log(this.first,this.second, "onIsPersonOne");
    },
    goStep() {
      var that = this;
      if (
        !this.second.SecondFullName ||
        this.second.SecondFullName.length == 0
      ) {
        Toast("姓名不能为空");
        return;
      }

      console.log(this.first,this.second, "goStep");

      if (this.stepindex == 1) {
        this.$router.replace({
          name: "Step03",
          params: { first: this.first, second: this.second, peopleCount: 2 },
        });
      }
    },

    afterReadfirst(file) {
      // 此时可以自行将文件上传至服务器
      var that = this;
      console.log(file);
      if (file.file.type.indexOf("image") > -1) {
        that.firstimg = file.content;
        that.first.FirstImg = file.content;
      }
    },
    afterReadsecond(file) {
      // 此时可以自行将文件上传至服务器
      var that = this;
      console.log(file);
      if (file.file.type.indexOf("image") > -1) {
        that.secondimg = file.content;
        that.second.SecondImg = file.content;
      }
    },
    cleanSc() {
      //清除生辰
      this.startDate = "";
      this.currenDate = "";
      this.startDateShow = false;
    },
    cleanJr() {
      //清除忌日
      this.endDate = "";
      this.currenEndDate = "";
      this.endDateShow = false;
    },
    cleanDate() {
      if (this.dateType == 1) {
        this.startDate = "";
        this.currenDate = "";
        this.startDateShow = false;
      } else {
        this.endDate = "";
        this.currenEndDate = "";
        this.endDateShow = false;
      }
      this.nlShow = false;
    },
    changeNl(type) {
      if (type == 1) {
        this.startDateShow = false;
      } else {
        this.endDateShow = false;
      }
      this.nlShow = true;
      this.dateType = type;
    },
    confirmNl(v, i) {
      //console.log(v,i,"confirmNl");
      var _text = v.toString().replaceAll(",", "");
      if (this.dateType == 1) {
        this.startDate = _text;
        if (this.stepindex == 0) {
          this.first.FirstBirthdayDateMode = 4;
          this.first.FirstNlBirthdayList = i;
        } else {
          this.second.SecondBirthdayDateMode = 4;
          this.second.SecondNlBirthdayList = i;
        }
      } else if (this.dateType == 2) {
        this.endDate = _text;
        if (this.stepindex == 0) {
          this.first.FirstPassAwayDateMode = 4;
          this.first.FirstNlPassAwayList = i;
        } else {
          this.second.SecondPassAwayDateMode = 4;
          this.second.SecondNlPassAwayList = i;
        }
      }
      this.nlShow = false;
    },
  },
  created() {
    var that = this;
    this.step = this.$route.query.s;
  },
};
</script>

<style>
.step02 .title {
  text-align: center;
  font-size: 16px;
  color: #fff;
  margin: 22% auto 20px;
}
.step02 .avatar-uploader {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.step02 .avatar-uploader .avatar {
  width: 130px;
  height: 130px;
  background: url("~@/assets/images/create/m_avatar_bg.png") center no-repeat;
  background-size: cover;
}
.step02 .avatar-uploader .avatar img {
  width: 100%;
  height: 100%;
  background-size: cover;
  padding: 12px;
  border-radius: 50%;
}
.step02 .avatar-uploader .tips {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.96);
  text-align: center;
}
</style>
